var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticStyle:{"padding-top":"120px"}},[_c('b-container',{staticClass:"text-center"},[_c('b-row',{attrs:{"align-v":"center","id":"header"}},[_c('b-col',{attrs:{"cols":"12"}},[_c('h1',[_vm._v("Webshop")])])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }